import {initWebComponent} from "@/helpers/web-component-helper";
import {clearGeoJsonLayers, setVisibleLayersIncludes} from "@/helpers/ol/ol-geo-json-helper";
import {hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {checkHeaderArrows} from "@/helpers/layer/info/layer-info-info-helper";

export class LayerInfoInfoItemHeaderArrowComponent extends HTMLElement {
    constructor(){
        super();

        const direction = this.getAttribute('data-direction')

        const template = document.createElement('template');

        template.innerHTML = `<button class="btn btn-sm btn-outline-secondary icon-btn">
            <span class="fa fa-arrow-` + direction + `"></span>
          </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            const scrollMenu =  document.querySelector(".scrollmenu");

            if(direction === 'left') {
                scrollMenu.scrollBy(-200, 0);

            } else {
                scrollMenu.scrollBy(200, 0);
            }

            setTimeout(() => {
                checkHeaderArrows()
            }, 500)

        })
    }
}

